import moment from "@wielink-application/shared/js/mixins/moment"

export default {
	mixins : [moment],
	data() {
		return {
			metadataFields: [],
			loadingMetadata: false,
			currentGroup: null,
			metadataCache: {},
			componentMapping: {
				'string': 'Input',
				'text': 'Textarea',
				'email': 'Email',
				'phone': 'Phone',
				'date': 'Date',
				'datetime': 'DateTime',
				'price': 'Price',
				'color': 'Color',
				'website': 'Website',
				'boolean': 'YesNo',
				'wysiwyg': 'Wysiwyg',
			}
		}
	},
	methods: {
		async fetchMetadataFields(group) {
			if (!group) {
				this.clearMetadata();
				return;
			}

			if (this.metadataCache[group]) {
				this.metadataFields = this.metadataCache[group];
				this.currentGroup = group;
				return;
			}

			// Voorkom dubbele calls voor dezelfde groep
			if (this.currentGroup === group && this.loadingMetadata) {
				return;
			}

			this.currentGroup = group;
			this.loadingMetadata = true;

			try {
				let response = await Helpers.Ajax.get(
					route('api.v1.assets.metadata-fields', {assetableGroup: group}),
					{},
					{ success: () => {} }
				);

				this.metadataFields = response.data || [];
				this.metadataCache[group] = this.metadataFields;
			} catch (error) {
				console.error('Fout bij ophalen metadata velden:', error);
				this.metadataFields = [];
				this.clearMetadata();
			} finally {
				this.loadingMetadata = false;
			}
		},
		prepareMetadata(existingMetadata = {}) {
			const metadata = {};

			this.metadataFields.forEach(field => {
				let defaultValue = field.definition_options?.default_value ?? '';
				if (defaultValue == 'currentdate' && field.definition_type == 'date') {
					defaultValue = this.moment().format('YYYY-MM-DD');
				}
				metadata[field.name] = existingMetadata[field.name] ?? defaultValue;
			});
			return metadata;
		},
		clearMetadata() {
			this.metadataFields = [];
			this.currentGroup = null;
			if (this.form && this.form.metadata) {
				this.form.metadata = {};
			}
		},
		getComponentForField(field) {
			return this.componentMapping[field.definition_type] || 'Input';
		}
	}
}